export default __webpack_public_path__ + "static/media/action_request.ad48a6fb.svg";